import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Room } from 'livekit-client';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LivekitService {
  room: Room | null = null;

  constructor(private http: HttpClient) {}

  async getToken(roomName: string, role: 'broadcaster' | 'viewer' | 'caller') {
    const authToken = localStorage.getItem('access_token');
    return firstValueFrom(
      this.http.post<any>(`${environment.apiUrl}livekit/token`, {
        room_name: roomName,
        role: role
      }, {
        headers: { 'Authorization': `Bearer ${authToken}` }
      })
    );
  }

  // Ab ye sirf room banata aur connect karta hai, event handling component mein hogi
  async joinRoom(roomName: string, role: 'broadcaster' | 'viewer' | 'caller'): Promise<Room> {
    const res = await this.getToken(roomName, role);

    this.room = new Room();
    await this.room.connect(res.server_url, res.token);

    if (role !== 'viewer') {
      await this.room.localParticipant.enableCameraAndMicrophone();
    }

    return this.room;
  }

  leaveRoom() {
    this.room?.disconnect();
    this.room = null;
  }
}